import { memo, useEffect } from 'react';
import { subscribe, unsubscribe } from 'pubsub-js';
import classNames from 'classnames';
import { RESET_FORMS_EVENT } from '../../utils/constants';
import { useAppointmentForm } from './useAppointmentForm';
import styles from './Forms.module.scss';
import { PatternFormat } from 'react-number-format';
import { SubmitButton } from './SubmitButton';

export const BottomForm = memo(({ onCreateContact }) => {
  const { formData, errors, isSubmitting, onInputChange, onFormSubmit, resetForm } = useAppointmentForm({
    onCreateContact
  });

  useEffect(() => {
    const token = subscribe(RESET_FORMS_EVENT, () => resetForm());

    return () => {
      unsubscribe(token);
    };
  }, []);

  return (
    <form onSubmit={onFormSubmit} className={styles.bottomFormContainer}>
      <input
        type="text"
        aria-label="First Name"
        className={classNames(styles.formInput, { [styles.inputError]: errors.firstName })}
        placeholder="First Name"
        name="firstName"
        value={formData.firstName}
        onChange={onInputChange}
      />
      <input
        type="text"
        aria-label="Last Name"
        className={classNames(styles.formInput, { [styles.inputError]: errors.lastName })}
        placeholder="Last Name"
        name="lastName"
        value={formData.lastName}
        onChange={onInputChange}
      />
      <input
        type="text"
        aria-label="Email"
        className={classNames(styles.formInput, { [styles.inputError]: errors.email })}
        placeholder="Email"
        name="email"
        value={formData.email}
        onChange={onInputChange}
      />
      <PatternFormat
        aria-label="Phone"
        className={classNames(styles.formInput, { [styles.inputError]: errors.phone })}
        format="###-###-####"
        placeholder="Phone (###-###-####)"
        name="phone"
        value={formData.phone}
        onChange={onInputChange}
      />
      <SubmitButton isSubmitting={isSubmitting} isBottom={true} />
    </form>
  );
});
